module.exports = __webpack_public_path__ + "static/media/english.ee3de217.png";